





















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Popup from '@/components/Popup/Popup.vue';
import { eventBus } from '@/constants/bus';

@Component({
	components: {
		Popup
	}
})
export default class PopupTrigger extends Vue {
	@Prop()
	listId!: string;

	public showPopup = false;

	get List(): any {
		return this.$store.getters['getListeById'](this.listId);
	}

	get ActiveGrandePeriodeIndex(): any {
		return this.$store.getters['getActiveGrandePeriodeIndex'];
	}

	public onClick(): void {
		if (this.showPopup) {
			this.closePopup();
		} else {
			this.openPopup();
			eventBus.$emit('openpopup', this.listId);
		}
	}

	public clickOutside(): void {
		this.closePopup();
	}

	public onCloseClick(): void {
		this.closePopup();
	}

	protected created(): void {
		eventBus.$on('openpopup', (listeId: string) => {
			if (listeId !== this.listId && this.showPopup) {
				this.closePopup();
			}
		});
	}

	private closePopup(): void {
		this.showPopup = false;
		this.$store.commit('setPopupOpenState', {
			listId: this.listId,
			state: false
		});
	}

	private openPopup(): void {
		this.showPopup = true;
		this.$store.commit('setPopupOpenState', {
			listId: this.listId,
			state: true
		});
	}

	@Watch('ActiveGrandePeriodeIndex')
	onGrandePeriodeChange() {
		this.showPopup = false;
	}
}
